// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-skeleton {
  background: var(--bg-card, #ffffff);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  animation: pulse 1.5s infinite ease-in-out;
}

.post-skeleton-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.post-skeleton-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--bg-secondary, #e0e0e0);
  margin-right: 12px;
}

.post-skeleton-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.post-skeleton-name {
  width: 120px;
  height: 14px;
  background-color: var(--bg-secondary, #e0e0e0);
  border-radius: 4px;
}

.post-skeleton-date {
  width: 80px;
  height: 10px;
  background-color: var(--bg-secondary, #e0e0e0);
  border-radius: 4px;
}

.post-skeleton-body {
  height: 16px;
  background-color: var(--bg-secondary, #e0e0e0);
  border-radius: 4px;
  margin-bottom: 8px;
  width: 100%;
}

.post-skeleton-body.short {
  width: 70%;
}

.post-skeleton-footer {
  height: 24px;
  background-color: var(--bg-secondary, #e0e0e0);
  border-radius: 4px;
  width: 60%;
  margin-top: 16px;
}

@keyframes pulse {
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
}
`, "",{"version":3,"sources":["webpack://./src/components/PostSkeleton/PostSkeleton.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,KAAK,YAAY,EAAE;EACnB,MAAM,UAAU,EAAE;EAClB,OAAO,YAAY,EAAE;AACvB","sourcesContent":[".post-skeleton {\n  background: var(--bg-card, #ffffff);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 16px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n.post-skeleton-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.post-skeleton-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: var(--bg-secondary, #e0e0e0);\n  margin-right: 12px;\n}\n\n.post-skeleton-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.post-skeleton-name {\n  width: 120px;\n  height: 14px;\n  background-color: var(--bg-secondary, #e0e0e0);\n  border-radius: 4px;\n}\n\n.post-skeleton-date {\n  width: 80px;\n  height: 10px;\n  background-color: var(--bg-secondary, #e0e0e0);\n  border-radius: 4px;\n}\n\n.post-skeleton-body {\n  height: 16px;\n  background-color: var(--bg-secondary, #e0e0e0);\n  border-radius: 4px;\n  margin-bottom: 8px;\n  width: 100%;\n}\n\n.post-skeleton-body.short {\n  width: 70%;\n}\n\n.post-skeleton-footer {\n  height: 24px;\n  background-color: var(--bg-secondary, #e0e0e0);\n  border-radius: 4px;\n  width: 60%;\n  margin-top: 16px;\n}\n\n@keyframes pulse {\n  0% { opacity: 0.6; }\n  50% { opacity: 1; }\n  100% { opacity: 0.6; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
